import { SOB_GUIDE_INTERIOR_ARTICLE_LINK, SOB_GUIDE_SALE_APARTMENT_ARTICLE_LINK } from 'shared/constants/links';
import { NBSP } from 'shared/constants/symbols';
import type { TBanner } from 'shared/types/banner';
import { EDealType, EOfferType } from 'shared/types/features';
import { withCianMedium } from 'shared/utils/links';

export const getSobGuideArticleBannerContent = (dealType: EDealType, offerType: EOfferType): TBanner => {
  const isSaleApartment = dealType === EDealType.Sale && offerType === EOfferType.Apartment;

  if (isSaleApartment) {
    return {
      title: 'Как избежать ошибок при продаже квартиры?',
      linkBtn: {
        url: withCianMedium(SOB_GUIDE_SALE_APARTMENT_ARTICLE_LINK, dealType),
        text: 'Читать статью',
      },
      imageClass: 'apart',
    };
  }

  return {
    title: `Как создать эстетичный интерьер, чтобы легко продать или${NBSP}сдать свою недвижимость`,
    linkBtn: {
      url: withCianMedium(SOB_GUIDE_INTERIOR_ARTICLE_LINK, dealType),
      text: 'Читать статью',
    },
    imageClass: 'house',
  };
};
